<template>
  <page :loading="loading" :layout="layout">
    <rest-page-error v-if="error" :error="error" />
    <slot v-else-if="visible" />
  </page>
</template>

<script>
import Page from '@/common/components/page/Page'
import RestApi from '@/core/services/RestApi'
import RestPageError from '@/common/components/rest/RestPageError'

export default {
  name: 'RestPage',

  components: { RestPageError, Page },

  provide() {
    return {
      restPage: this
    }
  },

  props: {
    fetchEndpoint: {
      type: [Object, Array, null],
      required: false
    },

    layout: {
      type: String,
      required: false
    }
  },

  data() {
    return {
      loading: true,
      visible: false,
      error: null
    }
  },

  created() {
    this.loadData()
  },

  methods: {
    reload() {
      this.loading = true
      this.visible = false
      this.error = null

      this.loadData()
    },

    loadData() {
      let endpoints = []
      if (Array.isArray(this.fetchEndpoint)) {
        endpoints = this.fetchEndpoint
      } else if (this.fetchEndpoint) {
        endpoints = [this.fetchEndpoint]
      }

      let promises = []
      endpoints.forEach(endpoint => {
        if (endpoint) {
          promises.push(
            RestApi(endpoint)
              .then(({ data }) => {
                endpoint.handler(data)
              })
              .catch(error => {
                this.loading = false
                this.error = error
                this.$emit('on-error', error)
              })
          )
        }
      })

      Promise.all(promises).then(() => {
        this.loading = false
        this.visible = true
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/common/components/rest/RestPage.vue